<script>
import { Bar } from 'vue-chartjs';

export default {
  name: 'BaseBarChart',
  mixins: [Bar],
  props: {
    labels: {
      type: Array,
      required: true,
    },
    dataSets: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.drawChart();
  },
  watch: {
    dataSets() {
      this.drawChart();
    },
  },
  methods: {
    drawChart() {
      this.renderChart({
        labels: this.labels,
        datasets: this.dataSets,
      }, {
        legend: {
          position: 'bottom',
        },
        scales: {
          yAxes: [{
            scaleLabel: {
              labelString: "Nombre d'élèves",
              display: true,
            },
            ticks: {
              min: 0,
            },
          }],
          xAxes: [{
            ticks: {
            },
          }],
        },
      }, [{ label: "Nombre d'élèves" }]);
    },
  },
};
</script>
